import { Button, Form, Input } from "antd";
import { useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { fetchEASStudents, setSearchID } from "redux/reducers/EASSlice";
import { AppURL } from "utils/Actions";
import styles from "./style.module.scss";

interface SearchByIDProps {
  desktop?: boolean;
  activeTab?: string;
  redirect?: boolean;
}

export default function SearchByID({
  desktop = false,
  redirect = false,
  activeTab
}: SearchByIDProps) {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { isLoading, searchID } = useAppSelector(state => state.eas);
  const dispatch = useAppDispatch();
  const classNames = [styles.container];
  if (desktop) {
    classNames.push(styles["container--desktop"]);
  }

  useEffect(() => {
    if (form) {
      if (searchID) {
        form.setFieldsValue(searchID);
      } else {
        form.resetFields();
      }
    }
  }, [form, searchID]);

  const handleOnFinish = useCallback(formData => {
    if (redirect) {
      if (location.pathname !== AppURL.school.easApplications) {
        dispatch(setSearchID(formData));
        const historyObject = {
          pathname: AppURL.school.easApplications,
          state: { activeTab }
        };
        history.push(historyObject);
      }
    }
    const params = {
      studentNum: formData.studentNum?.trim()
    };
    dispatch(fetchEASStudents(params));
  }, []);

  const handleChange = (changedFields: any[]) => {
    const value = changedFields[0].value;
    dispatch(setSearchID({ studentNum: value }));
  };

  return (
    <div className={classNames.join(" ")}>
      {redirect && <div style={{ marginBottom: "2rem" }}>{t("dashboard.card-4.desc")}</div>}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOnFinish}
        requiredMark={false}
        style={{ width: "100%" }}
        className={styles.form}
        onFieldsChange={handleChange}
      >
        <Form.Item
          required
          label={t("easApplications.search.id.idLabel")}
          name="studentNum"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "ID is required"
            }
          ]}
        >
          <Input allowClear autoComplete="off" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={isLoading}
            disabled={isLoading}
            style={{ marginTop: 8 }}
          >
            {t("easApplications.search.cta")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
